import React from "react";
import { connect } from "react-redux";

function withRoleVisibility(
  WrappedComponent,
  componentGroup = null,
  isVisible = null,
  isEditable = null,
  isRedir = false
) {
  let pos = new Error().stack;
  const RoleVisibilityManager = function(props) {
    let componentGroupComputed = !!componentGroup
      ? componentGroup
      : props.componentGroup;
    componentGroupComputed = !!componentGroupComputed
      ? componentGroupComputed.charAt(0).toLowerCase() +
        componentGroupComputed.slice(1)
      : null;

    //eslint-disable-next-line eqeqeq
    if (!componentGroup && props.readOnly == undefined) {
      console.warn(
        `Component wrapped with withRoleVisibility() should have componentGroup specified. Otherwise it will be readonly!\n ${pos}`
      );
    }

    let isVisibleFunc = !!props.isVisible ? props.isVisible : isVisible;
    let isEditableFunc = !!props.isEditable ? props.isEditable : isEditable;

    if (!props.isVisible && !isVisible) {
      isVisibleFunc = (o) => o.read;
    }
    if (!props.isEditable && !isEditable) {
      isEditableFunc = (o) => o.update;
    }

    let group = !!props.visibilityData
      ? props.visibilityData[componentGroupComputed]
      : null;

    let converted = null;

    if (!!group) {
      converted = {
        create: group.create.value,
        read: group.read.value,
        update: group.update.value,
        delete: group.delete.value,
      };
    }

    let isVisibleComputed =
      !!converted && isVisibleFunc ? isVisibleFunc(converted) : false;
    let isEditableComputed =
      !!converted && isEditableFunc ? isEditableFunc(converted) : false;

    if (!!isVisibleComputed) {
      return <WrappedComponent {...props} readOnly={!isEditableComputed} />;
    } else {
      if (!!isRedir) {
        window.location.href = "#/accessdenied";
      }
      return <></>;
    }
  };

  function mapStateToProps(state) {
    return {
      visibilityData:
        !!state.visibilityReducer &&
        !!state.visibilityReducer.data &&
        !!state.visibilityReducer.data.crudPermissions
          ? state.visibilityReducer.data.crudPermissions
          : [],
    };
  }

  return connect(mapStateToProps, null)(RoleVisibilityManager);
}

export default withRoleVisibility;
